import { render } from "./HBEHotelDataMatching.vue?vue&type=template&id=ec73c7bc"
import script from "./HBEHotelDataMatching.vue?vue&type=script&lang=js"
export * from "./HBEHotelDataMatching.vue?vue&type=script&lang=js"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__